import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';

import useWindowSize from 'global/utils/useWindowSize';

import {
  Wrapper,
  MediaContainer,
  Image,
  TextBoxList,
  TextBox,
  LoadingIndicator,
} from './styles';

const SlideShow = ({ duration = 5000, slides }) => {
  const { isMobile } = useWindowSize();
  const [slideIndex, setSlideIndex] = useState(0);
  const currentSlide = slides[slideIndex];

  useEffect(() => {
    if (!slides?.length) {
      return null;
    }

    const startInterval = setInterval(() => {
      setSlideIndex((s) => {
        if (s >= slides.length - 1) {
          return 0;
        } else {
          return s + 1;
        }
      });
    }, duration);

    return () => {
      clearInterval(startInterval);
    };
  }, [duration, slides]);

  if (!slides?.length) {
    return null;
  }

  return (
    <Wrapper>
      {!isMobile && (
        <TextBoxList key={slideIndex}>
          {slides.map((slide, index) => (
            <TextBox
              key={index}
              as="div"
              duration={duration}
              isCurrent={index === slideIndex}
            >
              {slide.text}
              <LoadingIndicator />
            </TextBox>
          ))}
        </TextBoxList>
      )}
      <MediaContainer>
        {currentSlide.image && !currentSlide.video && (
          <Image
            alt="Illustrative image of text content"
            bg={currentSlide.image}
          />
        )}
        {currentSlide.video && (
          <video autoPlay loop muted playsInline controls={false}>
            <source src={currentSlide.video} />
          </video>
        )}
      </MediaContainer>
      {isMobile && (
        <TextBox key={slideIndex} isCurrent duration={duration}>
          {currentSlide.text}
          <LoadingIndicator />
        </TextBox>
      )}
    </Wrapper>
  );
};

SlideShow.propTypes = {
  /**
   * Duration (in ms) of each slide
   */
  duration: PropTypes.number,
  slides: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * Text can be either a string or a React/JSX element
       */
      text: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
      /**
       * Image url
       */
      image: PropTypes.string,
    })
  ),
};

export default SlideShow;
